import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Cookies from "js-cookie";
import { Flex, IconButton, SimpleGrid, Stack, StackProps } from "@chakra-ui/react";
import { ArrowLeftIcon, Button, Text } from "@looksrare/uikit";
import { languageList } from "@/config/localization";
import { NEXT_LOCALE } from "@/constants";

interface LanguageViewProps extends StackProps {
  onBack: () => void;
}

export const LanguageView = ({ onBack, ...props }: LanguageViewProps) => {
  const { t } = useTranslation();
  const { asPath, push, locale = "en" } = useRouter();
  const languageEntries = Object.entries(languageList);
  return (
    <Stack
      width="360px"
      border="1px solid"
      borderColor="border-01"
      borderRadius="container"
      bg="ui-01"
      // @todo-yg update this value across the app when colors are final
      boxShadow="0px 16px 24px 0px #0000003D"
      spacing={0}
      {...props}
    >
      <Flex width="100%" alignItems="center" gap={4} p={4}>
        <IconButton variant="ghost" onClick={onBack} aria-label="nav-profile-back">
          <ArrowLeftIcon boxSize={5} color="link-02" />
        </IconButton>
        <Text textStyle="heading-04" bold>
          {t("Language")}
        </Text>
      </Flex>
      <SimpleGrid columns={2} columnGap={2} rowGap={0} p={4}>
        {languageEntries.map(([languageKey, { name }]) => {
          const isCurrentLanguage = languageKey === locale;
          const handleClick = () => {
            Cookies.set(NEXT_LOCALE, languageKey, { expires: 30, sameSite: "strict", secure: true });
            push(asPath, undefined, { locale: languageKey });
          };
          return (
            <Button
              width="100%"
              key={name}
              variant="ghost"
              color={isCurrentLanguage ? undefined : "text-01"}
              fontWeight={isCurrentLanguage ? undefined : "normal"}
              borderRadius="mini"
              onClick={handleClick}
              justifyContent="flex-start"
              style={{ whiteSpace: "break-spaces" }}
              textAlign="left"
            >
              {name}
            </Button>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};
